import { PlanFirewallBilling, PlanFirewallPackage, PlanType } from 'services/accounts/types';
import { Optional } from './types';

export enum PaymentRedirectType {
    PLAN = 'plan',
}

export type PaymentRedirect =
    | PaymentRedirectPlanFirewall;

export type PaymentRedirectPlanFirewall = {
    id: string;
    type: PaymentRedirectType.PLAN;
    pangolin: string;
    plan: PlanType.FIREWALL;
    package: Optional<PlanFirewallPackage>;
    billing: Optional<PlanFirewallBilling>;
    history: string[];
    lastPaymentsCount: number;
};
